import type React from "react"

import { Box } from "@mui/material"
import type { BoxProps, SxProps, Theme } from "@mui/material"

type SxItem = Exclude<SxProps<Theme>, readonly unknown[]>

const toSxArray = (sx: SxProps<Theme> | undefined): readonly SxItem[] => {
  if (sx === undefined) {
    return []
  }

  return (Array.isArray(sx) ? sx : [sx]) as readonly SxItem[]
}

type DataGridFillProps = BoxProps

/**
 * Opt-in layout wrapper that fills remaining height in a flex-column parent
 * (typically PageCard with height 100%). Pass a ref to query
 * `.MuiDataGrid-virtualScroller` for infinite-scroll listeners.
 */
export const DataGridFill: React.FC<DataGridFillProps> = ({
  children,
  sx,
  ...rest
}) => (
  <Box
    {...rest}
    sx={[
      {
        display: "flex",
        flex: 1,
        flexDirection: "column",
        minHeight: 0,
        "& > *": {
          flex: 1,
          height: "100%",
          minHeight: 0,
        },
      },
      ...toSxArray(sx),
    ]}
  >
    {children}
  </Box>
)
